module.exports = __webpack_public_path__ + "img/warning.ff5e1e5f.svg";